function shuffle(array) {
  const _array = array.slice(0);
  for (let i = 0; i < array.length - 1; i++) {
    let randomIndex = Math.floor(Math.random() * (i + 1));
    let temp = _array[i];
    _array[i] = _array[randomIndex];
    _array[randomIndex] = temp;
  }
  return _array;
}

// '1', '2', '3', '4', '5', '6', '7', '8'


const initializeDeck = () => {
  let id = 0;
  const cards = [
    'BB8',
    'C-3PO',
    'han',
    'luke',
    'leia',
    'Snowtrooper2',
    'bd',
    'yoda'
  ].reduce((acc, type) => {
    acc.push({
      id: id++,
      type
    });
    acc.push({
      id: id++,
      type
    });
    return acc;
  }, []);

  return shuffle(cards);
};

export default initializeDeck;